import React, { useEffect, useState } from 'react';
import { Flex } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';

import { Authenticated } from '@/common/components/index.ts';
import { useApiProvider, useHeaderProvider } from '@/common/providers/index.ts';
import { getIntegrationsUserStatementUrl } from '@/common/queries/integrations.ts';
import ReglamentosYNormatividadPng from '@/assets/img/reglamentos-normatividad.png';
import ActualizacionDeDatosPng from '@/assets/img/actualizacion-datos.png';
import EstadoDeCuentaPng from '@/assets/img/estado-cuenta.png';
import SolicitudDeAuxiliosPng from '@/assets/img/solicitud-de-auxilios.png';
import SolicitudDeCreditoPng from '@/assets/img/solicitud-de-credito.png';

import styles from './view.module.scss';
import { DashboardLink } from './components/index.ts';

const DashboardView = () => {
  const { setTitle } = useHeaderProvider();
  const apiProvider = useApiProvider();

  const [externalToken, setExternalToken] = useState<string | null>(null);

  const integrationsUserStatementUrl = useQuery({
    queryKey: ['integrations', 'user_statement_url'],
    queryFn: async (qfnContext) =>
      getIntegrationsUserStatementUrl({ qfnContext, apiProvider })
  });

  useEffect(() => {
    setTitle('Dashboard');
  }, []);

  useEffect(() => {
    if (externalToken) {
      return;
    }

    (async () => {
      const response = await apiProvider.apiAuthenticated.post<{
        data: string;
      }>('/users/authorize-external');
      setExternalToken(response.data.data);
    })();
  }, [externalToken]);

  return (
    <Authenticated>
      <div className={styles.main}>
        <Flex justify={'space-between'} gap={20} wrap={'wrap'}>
          <DashboardLink
            title="Reglamentos & Normatividad"
            url="/legal/docs"
            imgUrl={ReglamentosYNormatividadPng}
          />
          <DashboardLink
            title="Actualización de Datos"
            url="/associate/information/update"
            imgUrl={ActualizacionDeDatosPng}
          />
          <DashboardLink
            title="Solicitud de Auxilios"
            url={`https://femcng.com/solicitud-de-auxilios?token=${externalToken}`}
            isExternal
            imgUrl={SolicitudDeAuxiliosPng}
          />
          <DashboardLink
            title="Solicitud de Crédito"
            url={`https://femcng.com/solicitud-de-credito?token=${externalToken}`}
            isExternal
            imgUrl={SolicitudDeCreditoPng}
          />
          {integrationsUserStatementUrl.isLoading ? (
            <DashboardLink
              title="Estado de Cuenta"
              isLoading
              imgUrl={EstadoDeCuentaPng}
            />
          ) : integrationsUserStatementUrl.data ? (
            <DashboardLink
              title="Estado de Cuenta"
              url={integrationsUserStatementUrl.data}
              imgUrl={EstadoDeCuentaPng}
              isExternal
            />
          ) : undefined}
        </Flex>
      </div>
    </Authenticated>
  );
};

export { DashboardView };
